import React, { useState, useEffect } from "react";
import "./index.css";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { Link, useNavigate } from "react-router-dom";
import favoriteIcon from "./icons/favorite.png";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import pharmacyAvatar from "./icons/pharmacyAvatar.jpg";
import FavoriteIcon from "@mui/icons-material/Favorite";
import axios from "axios";
import { getToken } from "../../auth/authenticate";
import { Button, CircularProgress, Drawer } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { api } from "services/ApiService";
import { PHARMACY_SERVICE_TYPES } from "constants/constants";
import PaginationComponent from "components/common/pagination/PaginationComponent";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#ffffff",
  color: "#8f8f8f",
  boxShadow: "1px 1px 1px 1px #d1d1d1",
  // '&:hover': {
  //   backgroundColor: alpha(theme.palette.common.white, 0.25),
  // },
  marginRight: theme.spacing(2),
  width: "100%",
  height: "50px",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(5),
    width: "70%",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1.5, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      // width: "30ch",
    },
  },
}));
const url = `${process.env.REACT_APP_BACKEND_URL}user/pharmacy`;
export const Pharmacies = () => {
  const [favorite, setFavorite] = useState(false);
  const navigate = useNavigate(-1);
  const [editIndex, setEditIndex] = useState(null);
  const [pharmacies, setPharmacies] = useState([]);
  const [loading, setLoading] = useState(false);

  const [serviceAreaAS, setServiceAreaAS] = useState("");
  const [deliveryAreaAS, setDeliveryAreaAS] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);

  const [page, setPage] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(0);
  const [limit, setLimit] = React.useState(10);
  const [offset, setOffset] = React.useState(0);

  useEffect(() => {
    fetchData();
  }, [page]);

  const handleChange = (value) => {
    setPage(value);
    if (value - 1 > 0) {
      setOffset((value - 1) * limit);
    } else {
      setOffset(0);
    }
  };

  const fetchData = async (isSearch=false) => {
    setLoading(true);
      let obj = {
        offset: offset,
        limit: limit,
        distance: deliveryAreaAS > 0 ? deliveryAreaAS : null,
        serviceArea:
          serviceAreaAS === "" || serviceAreaAS === "ALL"
            ? null
            : serviceAreaAS,
        search: searchText !== "" ? searchText : null,
      };
    const result = await api(url, "GET", obj);
    
    setPharmacies(result?.data?.data || []);
    setPageCount(Math.ceil(result?.data?.dataCount / limit));
    setLoading(false);
  };

  const addToFavourites = async (id) => {
    setLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const result = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}favourite/patient/add-pharmacy/${id}`,
      config
    );
    if (result) {
      alert("Added to favourites successfully");
      fetchData();
    }
    setLoading(false);
  };

  const removeFromFavourites = async (id) => {
    setLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const result = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}favourite/patient/remove-pharmacy/${id}`,
      config
    );
    if (result) {
      alert("Removed from favourites successfully");
      fetchData();
    }
    setLoading(false);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpenDrawer({ ...openDrawer, [anchor]: open });
  };

  const triggerSearch = () => {
    setOffset(0);
    setPage(1);
    setOpenDrawer({...openDrawer, ['right']: false })
    fetchData();
  };

  const resetAdvanceSearch=() => {
    setSearchText("");
    setDeliveryAreaAS(0);
    setServiceAreaAS("");
  }

  if (loading) {
    return (
      <center style={{ marginTop: 200 }}>
        <CircularProgress />
      </center>
    );
  }
  return (
    <>
      {/* setting drawer */}
      <div>
        <React.Fragment>
          <Drawer
            anchor={"right"}
            open={openDrawer["right"]}
            onClose={toggleDrawer("right", false)}
          >
            <>
              <div className="filter-drawer-main">
                <div
                  className="close-icon"
                  onClick={toggleDrawer("right", false)}
                >
                  <CloseIcon />
                </div>
                <p className="filter-heading">Search by Filter</p>
                <div className="filter-dropdown">
                  <select
                    onChange={(e) => setServiceAreaAS(e.target.value)}
                    name="Service Area"
                    id="gender"
                    value={serviceAreaAS}
                  >
                    <option value="">Service Area</option>
                    <option value="ALL">All</option>
                    <option value={PHARMACY_SERVICE_TYPES.ON_SIGHT}>
                      On Site
                    </option>
                    <option value={PHARMACY_SERVICE_TYPES.HOME_DELIVERY}>
                      Home Delivery
                    </option>
                    <option value={PHARMACY_SERVICE_TYPES.BOTH}>Both</option>
                  </select>
                </div>
                <div className="filter-star">
                  <h5 style={{ width: "250px" }}>Delivery Distance</h5>
                  <input
                    onChange={(e) => setDeliveryAreaAS(e.target.value)}
                    value={deliveryAreaAS}
                    type="number"
                    min="0"
                    step="1"
                    defaultValue={0}
                    onInput="validity.valid||(value='');"
                    style={styles.basicInput}
                  ></input>
                </div>

                {/* <div className="filter-star">
                      <ReactStars
                        count={5}
                        onChange={ratingChanged}
                        size={32}
                        activeColor="#F6D060"
                      />
                      <p>{"&"} Up</p>
                    </div> */}
              </div>
              <div className="drawer-btn">
                <Button variant="contained" onClick={resetAdvanceSearch}>
                  Reset
                </Button>
                <Button variant="contained" onClick={triggerSearch}>
                  Done
                </Button>
              </div>
            </>
          </Drawer>
        </React.Fragment>
      </div>
      <div className="pharmaciesMain">
        <Grid container>
          <Grid item xs={5} md={6} lg={7}>
            <div className="pharmaciesMainHeading">
              <h3>Pharmacies</h3>
            </div>
          </Grid>
          <Grid item xs={5} md={5} lg={4}>
            <Search className="pharmaciesSearchBox">
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search…"
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onBlur={() => fetchData(true)}
                onKeyPress={(event)=>{
                  if (event.key === 'Enter')
                  fetchData(true);
                }}
              />
            </Search>
          </Grid>
          <Grid item xs={2} md={1} lg={1}>
            <div className="tuneIcon" onClick={toggleDrawer("right", true)}>
              <TuneOutlinedIcon />
            </div>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            "& > :not(style)": {
              m: 1,
              width: "100%",
              height: "auto",
            },
          }}
        >
          <div className="scroll">
            {pharmacies?.map((pharmacy, index) => {
              return (
                <div key={index}>
                  <Paper elevation={1} className="pharmaciesData">
                    {pharmacy?.isFavourite ? (
                      <div
                        onClick={() => {
                          removeFromFavourites(pharmacy.pharmacyId);
                        }}
                      >
                        <FavoriteIcon
                          style={{
                            color: "red",
                            width: "15px",
                            height: "15px",
                          }}
                          className="favoriteIcon"
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          addToFavourites(pharmacy.pharmacyId);
                        }}
                      >
                        <img
                          src={favoriteIcon}
                          alt="Favorite Icon"
                          width={15}
                          height={15}
                          className="favoriteIcon"
                        />
                      </div>
                    )}
                    <Grid
                      container
                      className="pharmaciesMainGrid"
                      onClick={() =>
                        navigate(`pharmacy-info/${pharmacy.pharmacyId}`)
                      }
                    >
                      <Grid item xs={6} md={6} lg={8.5}>
                        <div className="pharmacyAvatar">
                          <Stack direction="row" spacing={1}>
                            <Avatar
                              alt="Patient Avatar"
                              src={pharmacy?.User?.profileImagePath || pharmacyAvatar}
                              variant="rounded"
                            />
                            <div className="pharmacyName">
                              <h5>{pharmacy.businessName}</h5>
                              <p>{pharmacy.district}</p>
                            </div>
                          </Stack>
                        </div>
                      </Grid>
                      <Grid item xs={2} md={2} lg={1.5}>
                        <div className="pharmaciesType ">
                          <p>Type</p>
                          <h5 className="textCapitalization">
                            {pharmacy.serviceArea}
                          </h5>
                        </div>
                      </Grid>
                      <Grid item xs={2} md={2} lg={1}>
                        <div className="pharmaciesType">
                          <p>Order</p>
                          <h5>0</h5>
                        </div>
                      </Grid>
                      <Grid item xs={2} md={2} lg={1}>
                        <div className="pharmacyMoreInfo">
                          <h6>More Info {">>"}</h6>
                        </div>
                      </Grid>
                    </Grid>
                  </Paper>
                </div>
              );
            })}
          </div>
        </Box>
        {/* Pagination */}
        {pharmacies?.length !== 0 && (
          <PaginationComponent
            count={pageCount}
            page={page}
            onChangeItem={handleChange}
          />
        )}
      </div>
    </>
  );
};

const styles = {
  basicInput: {
    width: "90%",
    outline: "none",
    borderColor: "transparent",
    padding: "-5px",
    marginLeft: "-4px",
  },
};